import { gql } from '@apollo/client';

export const GENERIC_FILTER_TEMPLATES_QUERY = gql`
  query genericFilterTemplates($pager: PagerInputNew, $filters: GenericFilterTemplatesFilterInput) {
    genericFilterTemplates(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        filterCondition
        isTemplate
      }
    }
  }
`;
